import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import NewLogin from "../../components/NewLogin";
import NewRegister from "../../components/NewRegister";


const LoginRegister = ({ intl, dispatch, user }) => {
  const [token, setToken] = React.useState(
    document.location.search.indexOf("resettoken") !== -1
      ? document.location.search.split("=")[1]
      : null
  );

  if (user && user.email) {
    return <Redirect to="/dashboard" />;
  }

  return (
    <section className="gray-bg mt-md-auto login-mobile">
      <Container>
        <Row>
          <Col lg={4}>
            <NewLogin
              dispatch={dispatch}
              token={token}
              intl={intl}
              setToken={setToken}
            />
          </Col>
          <Col lg={8}>
            <NewRegister dispatch={dispatch} intl={intl} />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps)(injectIntl(LoginRegister));
